import { Component, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

import { WelcomeScreen } from '@auth/shared/screen-data.interface';
import * as authActions from '@auth/store/auth.actions';
import { DataService } from '@data/data.service';

@Component({
  selector: 'app-welcome-screen',
  templateUrl: './welcome-screen.component.html',
  styleUrls: ['./welcome-screen.component.scss'],
})
export class WelcomeScreenComponent implements OnInit {
  logo: string;
  logoPlaceholder: string;

  constructor(private store: Store, public dataService: DataService) {
    this.dataService
      .getImage('logo')
      .pipe(take(1))
      .subscribe((response) => {
        const logoImage: HTMLElement = document.querySelector('#logoImage');

        if (response.status === 204 || response.status >= 400) {
          return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(response.body);
        reader.onloadend = () => {
          this.logo = reader.result.toString();
          logoImage.style.opacity = '1.0';
        };
      });
  }

  ngOnInit() {
    this.store.dispatch(new authActions.ChangeScreen(WelcomeScreen));
    this.dataService.init();
  }
}
